import {combineReducers} from 'redux';
import userReducer from './userReducer';
import appDataReducer from './appDataReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';
import icnSearch from './icnSearchReducer';
import icnSpeedSearch from './icnSpeedReducer';
import icnPlusSearch from './icnPlusReducer';
import icnAccelerationSearch from './icnAccelerationReducer';
import deviceSearchReducer from './deviceSearchReducer';
import accountSearchReducer from './accountSearchReducer';
import systemUnitsSearchReducer from './systemUnitsSearchReducer';
import icnBomListReducer from './icnBomListReducer';
import icnEventClassificationReducer from './icnEventClassificationReducer';

import crashboxxPdofReducer from './crashboxx/crashboxxPdofReducer';
import crashboxxBomPredictiveReducer from './crashboxx/crashboxxBomPredictiveReducer';
import crashboxxDownloadSingleExcelReducer from './crashboxx/crashboxxDownloadSingleExcelReducer';
import crashboxxDownloadSinglePdfReducer from './crashboxx/crashboxxDownloadSinglePdfReducer';
import crashboxxDownloadSingleCsvReducer from './crashboxx/crashboxxDownloadSingleCsvReducer';

import crashboxxDownloadListCsvReducer from './crashboxx/crashboxxDownloadListCsvReducer';
import crashboxxDownloadListExcelReducer from './crashboxx/crashboxxDownloadListExcelReducer';
import crashboxxDownloadListPdfReducer from './crashboxx/crashboxxDownloadListPdfReducer';

import crashboxxDownloadAllListCsvReducer from './crashboxx/crashboxxDownloadAllListCsvReducer';
import crashboxxDownloadAllListExcelReducer from './crashboxx/crashboxxDownloadAllListExcelReducer';
import crashboxxDownloadAllListPdfReducer from './crashboxx/crashboxxDownloadAllListPdfReducer';

import googleSearchReducer from './googleSearchReducer';
import jasperReportReducer from './jasperReportReducer';
import gridReducer from './gridReducer';

import { routerReducer } from 'react-router-redux';
import { localeReducer as locale } from 'react-localize-redux';
import { i18nReducer } from 'react-redux-i18n';

/*
    configurazione per l'uso dei miei reducer.

    qui sto indicando a redux che esiste una classe "courseReducer" da chiamare per l'action CREATE_COURSE
    chi invocherà il reducer lo potrà fare con
    statement.courses.....
*/

/**
 * root reducer di redux
 */
const rootReducer = combineReducers(Object.assign({}, {user: userReducer, appData: appDataReducer, ajaxCallsInProgress,
    icnSearch: icnSearch,
    icnPlus: icnPlusSearch,
    icnSpeed: icnSpeedSearch,
    icnAcceleration: icnAccelerationSearch,
    icnBomList: icnBomListReducer,
    eventClassification: icnEventClassificationReducer,
    crashboxxPdof: crashboxxPdofReducer,
    crashboxxBom: crashboxxBomPredictiveReducer,
    singleExcel: crashboxxDownloadSingleExcelReducer,
    singlePdf: crashboxxDownloadSinglePdfReducer,
    singleCsv: crashboxxDownloadSingleCsvReducer,

    csvList: crashboxxDownloadListCsvReducer,
    excelList: crashboxxDownloadListExcelReducer,
    pdfList: crashboxxDownloadListPdfReducer,

    csvAllList: crashboxxDownloadAllListCsvReducer,
    excelAllList: crashboxxDownloadAllListExcelReducer,
    pdfAllList: crashboxxDownloadAllListPdfReducer,

    deviceSearch: deviceSearchReducer, accountSearch: accountSearchReducer,
    systemUnitsSearch: systemUnitsSearchReducer,
    jasperReport: jasperReportReducer,
    grid: gridReducer,
    googleSearch: googleSearchReducer, i18n: i18nReducer},
    {locale}, { routing: routerReducer }));

export default rootReducer;




// WEBPACK FOOTER //
// ./src/reducers/index.js